export default "__VITE_ASSET__D$YLfwMj__"